import CacheStatus from './interfaces/CacheStatus';
import CacheInstallationState from './interfaces/CacheInstallationState';
import { setItem } from 'owa-local-storage';
import { setConsecutiveErrorCount, getConsecutiveErrorCount } from './consecutiveErrorCount';
import getKeyName from './getKeyName';

const INSTALLED_CACHE_VERSION: string = 'CacheVersion';
const ATTEMPTED_CACHE_VERSION: string = 'AttemptedCacheVersion';

export default function updateCacheDiagnostics(
    windowObj: Window,
    state: CacheInstallationState,
    cacheStatus: CacheStatus,
    cacheVersion: string
): void {
    switch (cacheStatus) {
        case CacheStatus.CacheInstalled:
            setItem(windowObj, getKeyName(state.appName, INSTALLED_CACHE_VERSION), cacheVersion);
            setConsecutiveErrorCount(windowObj, state, 0);
            break;
        case CacheStatus.CacheFailed:
            setItem(windowObj, getKeyName(state.appName, ATTEMPTED_CACHE_VERSION), cacheVersion);
            let errorCount = getConsecutiveErrorCount(windowObj, state);
            setConsecutiveErrorCount(windowObj, state, errorCount + 1);
            break;
        case CacheStatus.CacheCleared:
            setItem(windowObj, getKeyName(state.appName, INSTALLED_CACHE_VERSION), null);
            setItem(windowObj, getKeyName(state.appName, ATTEMPTED_CACHE_VERSION), null);
            setConsecutiveErrorCount(windowObj, state, 0);
            break;
    }
}
